import { SplitFactory } from '@splitsoftware/splitio';

export default class SplitIO {
  private client?: SplitIO.IClient;

  private getConfig = (key: string) => ({
    core: {
      key,
      authorizationKey: process.env.SPLITIO_KEY as string,
    },
  });

  private setClient = (client: SplitIO.IClient) => {
    this.client = client;
  };

  public getClient = () => this.client;

  public createClient = (key: string) => {
    const config = this.getConfig(key);
    const client = SplitFactory(config).client();
    this.setClient(client);

    return client;
  };
}
